angular.module("vgresiduos").component("clientResidueTextComplete", {
	controller: "clientResidueTextCompleteCtrl",
	templateUrl: "views/components/fields/clientResidueTextComplete/clientResidueTextComplete_template.html",
	bindings: {
		model: "=?"
	}
});
